import { jsx as _jsx } from "react/jsx-runtime";
import { FunctionalLoader } from 'seagull';
import { BootRetryScreen } from '~/components/BootRetryScreen/BootRetryScreen';
import { useIoContext } from '~/contexts';
import { useBootStalled } from '~/hooks/useBootStalled';
import { useLocaleKeys } from '~/i18n';
export const BeforeAuthFlowDone = (param)=>{
    let { stalledAfterMs } = param;
    const bootStalled = useBootStalled(stalledAfterMs);
    const { t } = useLocaleKeys('common.bootRetry');
    const { browser: { locationReload } } = useIoContext();
    if (bootStalled) {
        return /*#__PURE__*/ _jsx(BootRetryScreen, {
            biName: "boot_stalled_retry",
            onRetry: locationReload,
            title: t.title(),
            body: t.body(),
            retryLabel: t.retry()
        });
    }
    return /*#__PURE__*/ _jsx(FunctionalLoader, {
        name: "waitForAuthFlowDone",
        show: true
    });
};
